import { render, staticRenderFns } from "./DeviceStatusCard.vue?vue&type=template&id=12fba262"
import script from "./DeviceStatusCard.vue?vue&type=script&lang=js"
export * from "./DeviceStatusCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports